const InLobbyNote = ({name=""}) => {
  return (
    <div className="flex justify-center items-center my-5 mx-auto flex-col ">
    <img className="mb-5" src={require("../../assets/img/images.jpeg")} alt="event_image" />
      <p className="text-orange-500 text-sm text-center">Welcome {name}, You are currently in the lobby. The host will let you in when the event starts.</p>
    </div>
  );
};

export default InLobbyNote